import Stack from "@mui/material/Stack";
import type { GridValidRowModel } from "@mui/x-data-grid";

import {
  createSelectEditCellRenderer,
  createSelectViewCellRenderer,
  type SelectOption,
} from "./SelectCell";

const FLAG_WIDTH = 20;
const FLAG_HEIGHT = 14;

export interface FlagOption extends SelectOption {
  flagSrc: string;
  flagAlt?: string;
  flagWidth?: number;
  flagHeight?: number;
}

function renderFlag(option: FlagOption) {
  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <img
        src={option.flagSrc}
        alt={option.flagAlt ?? ""}
        width={option.flagWidth ?? FLAG_WIDTH}
        height={option.flagHeight ?? FLAG_HEIGHT}
      />
      <span>{option.label}</span>
    </Stack>
  );
}

export function createFlagViewCellRenderer<Row extends GridValidRowModel>(
  optionMap: Map<string, FlagOption>,
) {
  return createSelectViewCellRenderer<Row, FlagOption>(optionMap, renderFlag);
}

export function createFlagSelectEditCellRenderer<Row extends GridValidRowModel>(
  options: FlagOption[],
) {
  return createSelectEditCellRenderer<Row, FlagOption>(options, renderFlag);
}
